import { render, staticRenderFns } from "./ParticipantEmergency.vue?vue&type=template&id=5bfe2bfc&scoped=true&"
import script from "./ParticipantEmergency.vue?vue&type=script&lang=js&"
export * from "./ParticipantEmergency.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantEmergency.vue?vue&type=style&index=0&id=5bfe2bfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe2bfc",
  null
  
)

export default component.exports